import { lazy } from "react";

import AppIcons from "../../components/Base/AppIcons";

const PinesCrcOlimpia = lazy(() => import("./PinesCrcOlimpia"));
const ViewRecaudo = lazy(() => import("./ModuleRecaudo/views/ViewRecaudo"));
const ViewDevolucion = lazy(()=> import("./ModuleDevolucion/views/ViewDevolucion"))

export const listaPermisosPinesCrcOlimpia = [910, 911]

const rutasPinesCRCOlimpia = {
  link: "/Pines/PinesCrcOlimpia",
  label: <AppIcons Logo={"PINES_GENERACION_LICENCIA"} name="Pines CRC Olimpia" />,
  component: PinesCrcOlimpia,
  permission: [910, 911],
  subRoutes: [
    {
      link: "/Pines/PinesCrcOlimpia/recaudo",
      label: <AppIcons Logo={"PINES_CREAR"} name={"Venta Pines CRC Olimpia"} />,
      component: ViewRecaudo,
      permission: [910],
    },
    {
      link: "/Pines/PinesCrcOlimpia/devoluciones",
      label: <AppIcons Logo={"PINES_TRAMITAR"} name={"Devolución Pines CRC Olimpia"} />,
      component: ViewDevolucion,
      permission: [911],
    }
  ],
  show: true,
};

export default rutasPinesCRCOlimpia;
